/**
 * Job Service
 * API service for all job-related operations
 */

import apiClient from '../../../../apiClient';

const BASE_URL = '/ta/jobs';

export const jobService = {
  // Get all jobs with optional filters
  async getAllJobs(filters = {}) {
    try {
      const params = new URLSearchParams(filters);
      const response = await apiClient.get(`${BASE_URL}?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching jobs:', error);
      throw error;
    }
  },

  // Get single job by ID
  async getJobById(id) {
    try {
      const response = await apiClient.get(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching job ${id}:`, error);
      throw error;
    }
  },

  // Get jobs dropdown (for candidate form)
  async getJobsDropdown() {
    try {
      const response = await apiClient.get(`${BASE_URL}/dropdown`);
      return response.data;
    } catch (error) {
      console.error('Error fetching jobs dropdown:', error);
      throw error;
    }
  },

  // Get job statuses
  async getJobStatuses() {
    try {
      const response = await apiClient.get(`${BASE_URL}/statuses`);
      return response.data;
    } catch (error) {
      console.error('Error fetching job statuses:', error);
      throw error;
    }
  },

    // Get job stages
    async getJobStages() {
      try {
        const response = await apiClient.get(`${BASE_URL}/stages`);
        return response.data;
      } catch (error) {
        console.error('Error fetching job stages:', error);
        throw error;
      }
    },
  

  // Create new job
  async createJob(jobData) {
    try {
      const response = await apiClient.post(BASE_URL, jobData);
      return response.data;
    } catch (error) {
      console.error('Error creating job:', error);
      throw error;
    }
  },

  // Update job
  async updateJob(id, jobData) {
    try {
      const response = await apiClient.put(`${BASE_URL}/${id}`, jobData);
      return response.data;
    } catch (error) {
      console.error(`Error updating job ${id}:`, error);
      throw error;
    }
  },

  // Delete job
  async deleteJob(id) {
    try {
      const response = await apiClient.delete(`${BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting job ${id}:`, error);
      throw error;
    }
  },

  // Bulk update jobs (for inline editing)
  async bulkUpdateJobs(updates) {
    try {
      const response = await apiClient.post(`${BASE_URL}/bulk-update`, {
        updates
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk updating jobs:', error);
      throw error;
    }
  },

  // Get rejection/withdrawal reasons
  async getRejectionReasons(reasonType = null) {
    try {
      const url = reasonType
        ? `${BASE_URL}/rejection-reasons?reason_type=${reasonType}`
        : `${BASE_URL}/rejection-reasons`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching rejection reasons:', error);
      throw error;
    }
  }
};

export default jobService;
